// i18n area 'cluster' — locale fi-FI (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.fi-FI.meta.json.
import type { enUS } from './cluster'

export const fiFI: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Takuukäytöt',
      subtitle: 'Solmun huolto-ovi: vain luku -käyttö tilapäisellä salasanalla ja hätätili kassakaapin salasanalla',
      readOnlyTitle: 'Vain luku -käyttö (trantor)',
      stateNone: 'suljettu',
      stateGranted: 'avoin',
      stateGrantedPending: 'myönnetty — otetaan käyttöön solmussa',
      grantedBy: 'Myöntäjä',
      grantedAt: 'Myönnetty',
      expiresAt: 'Vanhenee',
      reason: 'Syy',
      endedAt: 'Suljettu',
      endedReason: {
        revoked: 'peruutettu',
        expired: 'vanhentunut (TTL)',
        reboot: 'solmun uudelleenkäynnistys',
        failed: 'ei otettu käyttöön (tehtävä epäonnistui)'
      },
      grant: 'Myönnä vain luku -käyttö…',
      grantTitle: 'Myönnä vain luku -käyttö',
      grantSubmit: 'Myönnä',
      grantError: 'Myöntäminen hylättiin',
      grantConfirm: 'TVirt luo tilapäisen salasanan järjestelmäkäyttäjälle «trantor» (vain luku: journal ja diagnostiikka, ei sudoa) ja asettaa sen solmuun tehtävällä. Salasana näytetään VAIN kerran, vahvistettaessa; se lakkaa vanhentuessaan, peruutettaessa tai solmun seuraavassa uudelleenkäynnistyksessä.',
      reasonLabel: 'Syy',
      reasonHint: 'Miksi avaat oven: se kirjataan myöntöön, auditointiin ja lokikirjaan',
      ttlLabel: 'Kesto',
      ttlHours: '{n} h',
      revoke: 'Peruuta vain luku -käyttö…',
      revokeTitle: 'Peruuta vain luku -käyttö',
      revokeSubmit: 'Peruuta',
      revokeError: 'Peruutus hylättiin',
      revokeConfirm: 'Myöntö päättyy heti ja tehtävä lukitsee käyttäjän «trantor» solmussa uudelleen: tilapäinen salasana lakkaa toimimasta.',
      passwordTitle: 'Vain luku -salasana',
      passwordOnce: 'Tämä salasana näytetään VAIN kerran: kopioi se nyt. Sitä ei tallenneta minnekään eikä sitä voi lukea uudelleen — jos hukkaat sen, myönnä uudelleen.',
      passwordUser: 'Käyttäjä',
      passwordLabel: 'Salasana',
      passwordHint: 'Voimassa {until} asti tai solmun seuraavaan uudelleenkäynnistykseen; käytettävissä, kun myöntötehtävä on valmis. Yhteys: ssh trantor@<solmun osoite>.',
      emergencyTitle: 'Viimeisin hätäkäyttö (trantor-emergency)',
      lastLogin: '{time} kautta {via} osoitteesta {from}',
      lastLoginNone: 'ei havaittu',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'konsoli',
        sudo: 'sudo',
        unknown: 'tuntematon'
      },
      emergencyHint: 'Hätätili «trantor-emergency» (täysi sudo) on aina käytössä salasanalla, joka luotiin solmun asennuksessa ja säilytetään kassakaapissa: TVirt ei tunne, kierrätä eikä palauta sitä. Jokainen kirjautuminen raportoidaan tässä ja tapahtumalokissa.'
    },
    nodeFirewall: {
      tab: 'Palomuuri',
      title: 'Solmujen palomuuri',
      subtitle: 'Sen nftables-rulesetin asento, jonka jokainen solmu ottaa itsellään käyttöön — solmun ainoa palomuuri (firewalld on poistettu käytöstä)',
      modeLabel: 'Asento',
      mode: {
        disabled: 'Pois käytöstä — ei rulesetiä solmuilla',
        permissive: 'Salliva — laskee ja kirjaa lokiin, ei pudota mitään',
        enforced: 'Pakotettu — sisään pääsee vain johdettu rekisteri'
      },
      hint: {
        disabled: 'Kuten tänään: solmut eivät kanna mitään rulesetiä. Vaihda sallivaan LUKEAKSESI, mitä pudotettaisiin, ennen kuin se pudotetaan.',
        permissive: 'Jokainen solmu ottaa oman johdetun rulesetinsä käyttöön policy accept -tilassa: se, minkä pakotettu tila pudottaisi, lasketaan ja kirjataan lokiin (journalin etuliite «tvirt-node would-drop:»). Mitään ei estetä.',
        enforced: 'Jokainen solmu ottaa oman johdetun rulesetinsä käyttöön policy drop -tilassa: ssh ja API mistä tahansa, store / live migration / overlay / Ceph vain jäseniltä, verkkopalvelujen listenerit palvellusta verkosta. Jokainen vaihto on vahvistettava apply — solmu, joka ei pysty vahvistamaan, palaa itse takaisin.'
      },
      confirmTitle: 'Pakotetaanko solmujen palomuuri?',
      confirmBody: 'Jokainen solmu ottaa rulesetin käyttöön vahvistettavasti: se luotaa backendin, storen ja ssh:n uusien sääntöjen läpi määräajassa ja vahvistaa — muuten se palaa itse edelliseen rulesetiin. Lue ensin sallivan tilan laskurit solmuilta.',
      confirmSubmit: 'Pakota',
      confirmCancel: 'Peruuta',
      lensTitle: 'Solmun palomuuri',
      loadError: 'Solmun palomuurin linssiä ei voitu ladata',
      noReport: 'Ei vielä palomuuriraporttia tältä solmulta — worker raportoi seuraavalla kierroksellaan',
      firewalldActive: 'Tällä solmulla pyörii firewalld: solmun palomuuri kieltäytyy asettumasta sen rinnalle (maskaa firewalld)',
      conditionUnconfirmed: 'Ei vielä vahvistettua rulesetiä — solmu on auki',
      conditionRolledBack: 'Viimeisin apply palasi takaisin — samaa generaatiota ei yritetä uudelleen, ennen kuin rekisteri muuttuu tai asento vaihdetaan uudelleen',
      lastError: 'Viimeisin virhe',
      posture: 'Asento',
      observedAt: 'Havaittu',
      desiredGeneration: 'Haluttu generaatio',
      componentTitle: 'Solmun komponentti',
      componentSubtitle: 'tvirt-node-firewall — ottaa käynnistyksessä vahvistetun rulesetin käyttöön, palauttaa vahvistamattoman itse takaisin',
      componentAbsent: 'Komponentti ei ole vielä raportoinut',
      phase: 'Vaihe',
      phases: {
        none: 'Ei koskaan otettu käyttöön',
        applied: 'Otettu käyttöön — odottaa vahvistusta',
        confirmed: 'Vahvistettu',
        rolledBack: 'Palautettu takaisin'
      },
      generation: 'Generaatio',
      appliedAt: 'Otettu käyttöön',
      confirmedAt: 'Vahvistettu',
      deadline: 'Rollbackin määräaika',
      lastRollback: 'Viimeisin rollback',
      registryTitle: 'Johdettu rekisteri',
      registrySubtitle: 'Portit, jotka tämä solmu avaa, luokittain ja alkuperän mukaan — johdettu klusterista, ei koskaan käsin muokattu',
      registryEmpty: 'Mitään ei ole johdettu — asento pois käytöstä ilman vahvistettua rulesetiä, tai ei vielä raporttia',
      colClass: 'Luokka',
      colPort: 'Portti',
      colSource: 'Lähde',
      colOrigin: 'Alkuperä',
      classes: {
        public: 'Julkinen',
        internode: 'Solmujen välinen',
        tenant: 'Tenant'
      },
      sourceMembers: 'vain jäsenet',
      sourceAnywhere: 'mistä tahansa',
      sourceBridge: 'liitännällä {iface}'
    },
    derivationDerived: 'johdettu',
    derivationDiverged: 'poikennut',
    derivationDerivedTip: 'Verkkodokumentti on JOHDETTU fabricista {fabric} ja vastaa yhä renderiä nykyisillä syötteillä — klikkaa johdantasuunnitelmaan.',
    derivationDivergedTip: 'Johdanta fabricista {fabric} muuttui viimeisen applyn jälkeen (fabric, kaapelointi, roolit tai viittaukset) — klikkaa odottavaan diffiin.',
    derivationRetiring: {
      one: '{n} osoite tyhjenemässä',
      other: '{n} osoitetta tyhjenemässä'
    },
    standaloneHint: 'Tällä solmulla ei ole klusteria: sitä ei ole vielä asennettu. Klusterit luodaan TAI joinataan asennuksen yhteydessä — jäsenen Palvelimet-taulusta generoitu token syötetään installerille (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Oikeutesi kattavat yhden scopen, eivät koko klusteria: laivastoinventaario — solmut, asetukset ja laitteet — näkyy vain klusterin ylläpitäjille.',
    phaseReady: 'Valmis',
    phaseForming: 'Muodostumassa',
    storeMembers: 'Storen jäsenet',
    watermark: 'Konvergenssikynnys',
    configGeneration: 'Config-generaatio',
    converged: 'ajan tasalla',
    behind: 'jäljessä — {m} / {n}',
    revision: 'Revisio',
    rolesTitle: 'Verkkoroolit',
    rolesSubtitle: 'Kunkin liikenneluokan osoitteet jäsentä kohden — yhteydet elävät host-verkossa',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'perii managementin',
    settingsTitle: 'Asetukset',
    settingsSubtitle: 'Klusteritason tietoturvapolicy — jokainen solmu arvioi sen omasta paikallisesta replikastaan',
    taskRetentionTitle: 'Taskien säilytys',
    taskRetentionSubtitle: 'Yhtenäinen GC kaikille taskeille — ikärajan tai katon ylittäneet päättyneet taskit kerätään, käynnissä olevia ei koskaan',
    taskRetentionMaxAge: 'Enimmäisikä (päivää)',
    taskRetentionMaxCount: 'Taskien enimmäismäärä',
    eventRetentionTitle: 'Tapahtumien säilytys',
    eventRetentionSubtitle: 'Lokin GC — tehtävistä riippumaton politiikka: tehtävä on jono, tapahtuma on muistia',
    eventRetentionMaxAge: 'Enimmäisikä (päivää)',
    eventRetentionMaxCount: 'Tallennettujen tapahtumien enimmäismäärä',
    spaceThresholdsTitle: 'Tilan kynnysarvot',
    spaceThresholdsSubtitle: 'Milloin täyttyvä tallennustila päätyy lokiin (ja ilmoituksiin)',
    spaceLowPct: 'Varoitus alkaen (% käytetty)',
    spaceCriticalPct: 'Kriittinen alkaen (% käytetty)',
    spaceOrderError: 'Kriittinen ei voi olla varoituksen alapuolella',
    spaceThresholdsHint: 'Vain sisäänmenot määritetään: ulostulon johtaa moottori, 5 pistettä kunkin kynnyksen alle, jottei rajalla seisova tallennustila muutu metronomiksi',
    failoverReserveTitle: 'Failover-reservi',
    failoverReserveSubtitle: 'Admission control N+1 — RAM pidetään vapaana, jotta klusteri voi käynnistää kuormansa uudelleen solmujen menetyksen jälkeen',
    failoverReserveTolerate: 'Siedettävien solmumenetysten määrä',
    failoverReserveOff: '0 — reservi pois päältä: yhtäkään käynnistystä ei koskaan hylätä failover-kapasiteetin takia',
    failoverReserveOn: 'Käynnistys, joka söisi reserviä, hylätään 412-virheellä, joka selittää luvut',
    networkShapingTitle: 'Kaistan reiluus',
    networkShapingSubtitle: 'Uplink-kohtaisen shaping-puun kolme typologiapainoa — vaikuttavat vain kilpailutilanteessa',
    networkShapingRest: 'Muun liikenteen paino (ohjaustaso, storage, replikat)',
    networkShapingOverlay: 'Overlay-verkkojen paino',
    networkShapingLiveMigration: 'Live migrationin paino',
    networkShapingHint: 'Taattu osuus = paino / kolmen summa (oletus 300 / 100 / 200, kukin 1–10000); vapaalla linkillä jokainen luokka voi ottaa koko kaistan',
    debugModeTitle: 'Debug-tila',
    debugModeSubtitle:
      'Yksityiskohtaiset virheet GUI:n yleisissä ilmoituksissa — jotta näet todellisen syyn, kun ”epäonnistunut” toiminto oikeasti onnistui',
    debugModeLabel: 'Debug-tila käytössä',
    debugModeOn: 'Yleiset virheilmoitukset liittävät perään taustalla olevan syyn — sisäiset yksityiskohdat näkyvät jokaiselle operaattorille',
    debugModeOffHint: 'Pois päältä — yleiset virheilmoitukset pysyvät yleisinä, ilman sisäisiä yksityiskohtia',
    nodeDetailsAction: 'Solmun tiedot',
    node: {
      docTitle: 'Solmu',
      notFound: 'Solmua ei löytynyt',
      tabOverview: 'Yleiskatsaus',
      tabStats: 'Tilastot',
      tabNetwork: 'Verkko',
      tabSettings: 'Paikalliset asetukset',
      identityTitle: 'Identiteetti',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'YSQL-portti',
      revision: 'Config-revisio',
      versionsTitle: 'Havaitut versiot',
      heartbeatSubtitle: 'Viimeisin tila, jonka solmu on raportoinut itsestään',
      cpuTitle: 'CPU',
      cpuModelTitle: 'CPU-malli',
      memoryTitle: 'Muisti',
      hugePagesTitle: 'Jättisivut',
      hugePagesPool: '{size}: {free} vapaana / {total}',
      hugePagesNone: 'Ei varantoa',
      hugePagesNoneHint: 'Solmulla ei ole varattuja jättisivuja: niitä pyytävät virtuaalikoneet eivät voi käynnistyä täällä. Varanto ilmoitetaan solmussa ytimen hugepagesz- ja hugepages-parametreilla tai kirjoittamalla nr_hugepages.',
      usageTitle: 'Nykyinen käyttö',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'ei havaittu — ei tuoretta näytettä',
      statsNoData: 'Ei dataa valitulla välillä — solmun sarjat näytteistää solmu itse ja ne tarjoillaan paikallisesti.',
      observedTitle: 'Havaittu tila',
      observedSubtitle: 'Solmun paikalliset palvelut ja assetit workerin näkeminä'
    },
    editRolesTitle: 'Muokkaa verkkorooleja',
    memberNode: 'Solmu',
    memberIp: 'IP-osoite',
    addMember: 'Lisää jäsen',
    lmInherit: 'Käytä management-osoitteita',
    roleIpHint: 'Jäsenten lisääminen ja poistaminen on vapaata; olemassa olevan jäsenen IP:n muuttaminen paikallaan hylätään — IP-migroinnin työnkulku saapuu myöhemmässä roundissa.',
    roleError: 'Rooleja ei voitu päivittää',
    nodesTitle: 'Solmut',
    addNodeTitle: 'Lisää solmu klusteriin',
    addNode: 'Lisää solmu',
    addNodeError: 'Solmua ei voitu esirekisteröidä',
    nodeName: 'Solmun nimi',
    nodeNameHint: 'täytyy täsmätä asennuksessa valittuun nimeen',
    nodeIp: 'Management-IP',
    colName: 'Nimi',
    colPhase: 'Vaihe',
    colServices: 'Palvelut',
    colWatermark: 'Watermark',
    colLastSeen: 'Viimeisin yhteys',
    colUps: 'UPS',
    upsCordonChip: 'UPS-eristys',
    upsCordonTip: 'Solmu tuomitsi itsensä UPS:nsä tosiasioiden perusteella ({time}): se purkaa eristyksen itse, kun verkko on vakaa ja akku ladattu',
    upsUnreachable: 'UPS ei tavoitettavissa',
    upsOnBattery: 'Akulla',
    upsOnLine: 'Verkkovirralla',
    upsLowBattery: 'akku vähissä',
    upsNoEstimateChip: 'jäljellä olevaa aikaa ei arvioitu',
    upsNoEstimateTip: 'UPS ei julkaise arviota jäljellä olevasta ajasta: solmu tuomitaan vain UPS:n LB-lipun (akku vähissä) perusteella — säädä battery.runtime.low / LB itse UPS:ssä',
    upsLaneTip: 'UPS-sammutuspolku alkaen {since}: tuomitsija {by}',
    upsUnit: 'yksikkö',
    upsStatus: 'NUT-tila',
    upsLoad: 'kuorma',
    upsOnBatterySince: 'akulla alkaen',
    upsOnLineSince: 'verkkovirralla alkaen',
    upsError: 'virhe',
    upsObservedAt: 'havaittu',
    upsNone: 'mikään UPS-yksikkö ei palvele tätä solmua',
    upsBy: {
      runtime: 'jäljellä oleva aika alle kynnyksen',
      lowBattery: 'UPS:n LB-lippu',
    },
    upsLane: {
      evacuate: 'evakuointi',
      local: 'sammutus paikan päällä',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'pysäytetään vieraita',
      stoppingServices: 'pysäytetään palveluita',
      poweredOff: 'sammutettu',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'UPS-yksiköt ja kynnykset: solmu tuomitaan, kun jäljellä oleva aika ≤ kynnys tai LB-lippu (aina kunnioitettu), jatkaminen hystereesillä',
    upsRuntimeThreshold: 'Jäljellä olevan ajan kynnys (s)',
    upsRuntimeThresholdHint: 'Akulla, kun arvioitu jäljellä oleva aika ≤ kynnys, solmu sammuu järjestyksessä (oletus 300)',
    upsResumeStable: 'Verkko vakaa (s)',
    upsResumeStableHint: 'Jatketaan vain, kun verkko on ollut yhtäjaksoisesti vähintään näin monta sekuntia (oletus 60)',
    upsResumeCharge: 'Vähimmäislataus jatkettaessa (%)',
    upsResumeChargeHint: 'Ja akku ladattu vähintään tähän prosenttiin (oletus 25)',
    upsPolicyNote: 'UPS:n LB-lippu (akku vähissä) tuomitsee aina eikä sitä voi poistaa käytöstä; akulla vietetylle ajalle ei ole kynnystä. Jokainen yksikkö voi ohittaa kolme lukua.',
    upsUnitNew: 'uusi yksikkö',
    upsUnitSelectors: '{n} tunnistevalitsin(ta) (vain CLI)',
    upsUnitName: 'Yksikön nimi',
    upsUnitMode: 'Tila',
    upsModeExternal: 'ulkoinen (toisen upsd)',
    upsModeManaged: 'hallittu (UPS kytketty solmuun)',
    upsUnitUpsname: 'NUT-nimi (upsname)',
    upsUnitHost: 'upsd-isäntä',
    upsUnitAttachedNode: 'Kytketty solmu',
    upsUnitDriver: 'NUT-ajuri',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Ajurin laite',
    upsUnitDeviceHint: 'ups.conf-tiedoston port=-rivi: tyhjä = auto',
    upsUnitPort: 'upsd-portti',
    upsUnitServedNodes: 'Palvellut solmut',
    upsUnitServedNodesHint: 'solmujen nimet pilkuilla erotettuina (tunnistevalitsimet CLI:n kautta)',
    upsUnitOverrideHint: 'tyhjä = klusterin oletus',
    upsUnitAdd: 'Lisää yksikkö',
    unreachableSince: 'Tavoittamattomissa — viimeisin heartbeat {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Overlay-dataplane ei ole vielä toteuttanut nykyistä overlay-konfiguraatiota',
    overlaysError: 'Viimeisin overlay-täsmäytysajo epäonnistui: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Odottaa joinia',
      'joining': 'Liittymässä',
      'member': 'Jäsen'
    },
    tokenTitle: 'Join token',
    tokenOnce: 'Näytetään vain nyt — kopioi se heti, se ei ole enää myöhemmin luettavissa',
    copy: 'Kopioi',
    copied: 'Kopioitu',
    close: 'Sulje',
    revokeTitle: 'Peru esirekisteröinti',
    revoke: 'Peru',
    revokeError: 'Rekisteröintiä ei voitu perua',
    promote: 'Ylennä store-memberiksi',
    demote: 'Poista store-member-rooli',
    troubleshoot: 'Vianmääritys',
    promoteTitle: 'Ylennä store-memberiksi',
    demoteTitle: 'Poista store-member-rooli',
    promoteHint: 'Solmu liittyy YugabyteDB-masterien quorumiin. Todellinen HA vaatii kolme store-memberiä.',
    demoteHint: 'Solmu poistuu masterien quorumista ja pysäyttää store-palvelunsa.',
    storeError: 'Store-memberin muutos hylättiin',
    attest: 'Attestoi sammuneeksi…',
    attestTitle: 'Attestoi solmu sammuneeksi',
    attestSubmit: 'Attestoi sammuneeksi',
    attestConfirm: 'Ilmoitat tämän solmun sammuneeksi omalla riskilläsi: todellisuudessa elossa olevan solmun attestointi voi johtaa VM:ien kaksoisajoon. Sen taskit merkitään epäonnistuneiksi ja sen VM:ien authorityt muuttuvat siirrettäviksi.',
    attestError: 'Attestointi hylättiin',
    attestedChip: 'attestoitu sammuneeksi',
    maintenanceChip: 'huolto',
    guestToolsChip: 'TVirt Guest Tools (solmun paikallinen ISO-asset)',
    maintenanceEnter: 'Aseta huoltotilaan',
    maintenanceExit: 'Poista huoltotilasta',
    maintenanceEnterTitle: 'Aseta huoltotilaan',
    maintenanceExitTitle: 'Poista huoltotilasta',
    maintenanceEnterSubmit: 'Aseta huoltotilaan',
    maintenanceExitSubmit: 'Poista huoltotilasta',
    maintenanceEnterConfirm: 'Solmu eristetään ja tyhjennetään: verkkopalvelut ja App-instanssit, joiden authority sillä on, siirretään (instanssit kylmänä: pysäytetään ja niitetään täällä, luodaan uudelleen kohdesolmussa — käyttökatko), käynnissä olevat VM:t migroidaan livenä missä mahdollista ja muuten pysäytetään siististi, keskeneräiset tehtävät valmistuvat, uusi työ odottaa ja pysäytetyt VM:t menettävät authorityn — Proximity sijoittaa ne uudelleen seuraavassa käynnistyksessä. Mikään ei palaa itsestään huollon päättyessä.',
    maintenanceExitConfirm: 'Solmu jatkaa työskentelyä ja Proximity ottaa sen taas huomioon sijoittelussa. VM:t palaavat vasta kun ne käynnistetään.',
    maintenanceError: 'Huoltopyyntö hylättiin',
    maintenancePlanTitle: 'Evakuointisuunnitelma',
    maintenancePlanLoading: 'Lasketaan evakuointisuunnitelmaa…',
    maintenancePlanError: 'Evakuointisuunnitelmaa ei voitu ladata — drain migroi silti missä mahdollista ja pysäyttää loput.',
    maintenancePlanEmpty: 'Tässä solmussa ei ole mitään evakuoitavaa — ei aktiivista verkkopalvelua, ei käynnissä toivottua App-instanssia, ei käynnissä olevaa VM:ää.',
    maintenancePlanSummary: '{migrate} kohdetta migroidaan (VM:t, verkkopalvelut, App-instanssit), {stop} pysäytetään tai jää paikoilleen.',
    maintenancePlanReserve_ok: 'Failover-reservi tyhjennyksen jälkeen: ehjä — käynnistettävissä on yhä {headroom} GiB sietäen {n} solmun menetyksen.',
    maintenancePlanReserve_eroded: 'Failover-reservi tyhjennyksen jälkeen: lähes kulutettu — jäljellä on vain {headroom} GiB niistä {reserve} GiB:stä, jotka pidetään vapaana {n} solmuvian varalle.',
    maintenancePlanReserve_exhausted: 'Failover-reservi tyhjennyksen jälkeen: LOPUSSA — puuttuu {headroom} GiB niistä {reserve} GiB:stä, jotka tarvitaan sietämään {n} solmuvikaa. Niin kauan kuin tämä solmu on poissa, uudet VM-käynnistykset hylätään.',
    maintenancePlanReserve_unknown: 'Failover-reservi tyhjennyksen jälkeen: ei laskettavissa — yksikään jäljellä oleva solmu ei ole ilmoittanut muistiaan.',
    maintenancePlanReserveHugePages: 'Jättisivut ({size}) tyhjennyksen jälkeen — vapaana: {free} / {capacity}, reserviksi vaaditaan: {reserve}.',
    maintenancePlanActionMigrate: 'migroituu',
    maintenancePlanActionMigrateWarning: 'migroituu (soft-sääntöä rikotaan)',
    maintenancePlanActionStop: 'pysähtyy',
    maintenancePlanActionBlocked: 'estetty',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'verkkopalvelu',
    maintenancePlanKindApp: 'App-instanssi',
    maintenancePlanColdMove: 'Kylmä siirto: pod pysäytetään ja niitetään täällä ja kohdesolmun worker luo sen uudelleen — käyttökatko kohdeworkerin seuraavaan passiin asti.',
    caFingerprint: 'Klusterin CA:n fingerprint',
    staleChip: 'ei ajan tasalla',
    troubleshootTitle: 'Storen vianmääritys',
    restartStore: 'Käynnistä store-palvelut uudelleen',
    restartHint: 'Jos store oikuttelee, käynnistä sen palvelut uudelleen. Edistynyt toiminto — käytä varoen.',
    restartQueued: 'Uudelleenkäynnistystask jonossa',
    restartError: 'Palveluita ei voitu käynnistää uudelleen',
    svcActive: 'aktiivinen',
    svcWanted: 'haluttu, ei aktiivinen',
    svcStopped: 'pysähdyksissä',
    noServices: 'Ei raportoituja palveluita'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Koko klusterin GPU-inventaario malleittain ryhmiteltynä — solmuittain havaitut kortit, merkityt rekisteröinnit ja niiden tagit',
    usbTitle: 'USB-resurssit',
    usbSubtitle: 'Koko klusterin USB-inventaario malleittain ryhmiteltynä — solmuittain havaitut laitteet, molempien mallien rekisteröinnit (laitekohtainen, porttikohtainen) ja niiden tagit',
    markedChip: '{n} TVirtin käytettävissä',
    orphanChipGpu: '{n} orpoa',
    orphanChipUsb: '{n} orpoa',
    colNode: 'Solmu',
    colRegistration: 'Rekisteröinti',
      noRegsHint: 'Ei rekisteröintejä — laite merkitään "TVirtin käytettävissä" solmun dialogista (Solmut › solmu › Asetukset).',
      colDevice: 'Laite',
      colObserved: 'Havaitut',
      colRegs: 'Rekisteröinnit',
      regsNone: 'ei yhtään',
      colPci: 'PCIe-osoite',
      colIdentity: 'Identiteetti / portti',
      colClasses: 'Luokat (tagit)',
      colActions: 'Toiminnot',
      manageOnNode: 'Hallitse solmulla {node} (merkintä elää solmun dialogissa)',
      introTitle: 'Klusterin inventaario TVirt©:n käytettävissä olevista USB- ja PCIe-laitteista.',
      introStep1: '1. Solmut löytävät itse omat GPU:nsa ja USB-laitteensa (inventointi heartbeatissa).',
      introStep2: '2. Laite merkitään "TVirtin käytettävissä" SOLMUN dialogista (Solmut › solmu › Asetukset) — merkintä sitoo sen vfioon ja rekisteröi sen tänne.',
      introStep3: '3. Täällä annat rekisteröinneille niiden LUOKAT tagien kautta (esim. gpu_class=compute): VM:ien vaatimukset pyytävät luokkaa, ja scheduler valitsee solmun, jolla on vapaa yhteensopiva laite.',
    colMode: 'Moodi',
    colState: 'Tila',
    colNotes: 'Muistiinpanot',
    colTags: 'Tagit',
    modeDevice: 'laitekohtainen',
    modePort: 'porttikohtainen',
    usable: 'käytettävissä',
    orphanGpu: 'orpo',
    orphanUsb: 'orpo',
    hubChip: 'hub',
    orphanPortsTitle: 'Porttikohtaisia rekisteröintejä ilman kytkettyä laitetta — kytke laite takaisin tai poista merkinnät solmulta',
    gpusEmpty: 'Ei vielä havaittuja GPU:ita yhdelläkään solmulla',
    usbEmpty: 'Ei vielä havaittuja USB-laitteita yhdelläkään solmulla'
  },
  settings: {
    passwordMinLength: 'Salasanan vähimmäispituus',
    sessionIdle: 'Istunnon joutenolon timeout (minuuttia)',
    lockoutThreshold: 'Lukitus epäonnistuneiden yritysten jälkeen',
    lockoutDuration: 'Lukituksen kesto (minuuttia)',
    keyboardLayout: 'Näppäimistöasettelu',
    keyboardLayoutHint: 'esim. it, en-us — tyhjä käyttää QEMUn oletusta',
    syslogEndpoint: 'Syslog-endpoint',
    syslogEndpointHint: 'host:portti — tyhjä poistaa välityksen käytöstä',
    syslogTls: 'TLS',
    maxQueued: 'Taskien enimmäismäärä jonossa',
    concurrency: 'Workerin rinnakkaisuus',
    concurrencyHint: 'Worker ottaa käyttöön lennossa',
    notesTitle: 'Muistiinpanot',
    save: 'Tallenna',
    saved: 'Asetukset tallennettu',
    saveError: 'Asetuksia ei voitu tallentaa'
  },
  localSettings: {
    derivedChip: 'johdettu',
    derivedTip: 'Tämä device on fabric-johdannan OMISTAMA (H2): editori kieltäytyy koskemasta siihen — muokkaa fabricia (tai kaapelointia) ja sovella uudelleen, tai ota se takaisin alta.',
    takeOwnership: 'Ota omistus',
    takeOwnershipTitle: 'Ota omistus (take-ownership)',
    takeOwnershipConfirm: '{name} poistuu fabric-lohkosta ja palaa MANUAALISEKSI deviceksi, jota tämä editori hallitsee. Nodesta tulee poikennut, ja seuraava johdanta-apply hylkää sen kohdalla (manualConflict), kunnes nimeät sen uudelleen tai poistat sen — tai korjaat fabricin.',
    nodeSettingsTitle: 'Solmun asetukset',
    nodeSettingsSubtitle: 'Se, mitä tämä solmu soveltaa — task-jono, konsoli, lokien välitys — sekä sen tagit ja muistiinpanot',
    baseTitle: 'Host-reservit (TVirt Proximity)',
    baseSubtitle: 'Hostin käyttöjärjestelmälle varatut CPU ja RAM — empiirisen kapasiteetin syötteet, joilla Proximity sijoittaa VM:t',
    baseMemory: 'Perus-RAM (MiB)',
    baseMemoryHint: 'Havaittu kokonaismäärä: {total} MiB. VM:ille käytettävissä = kokonaismäärä − perusosa − tänne sijoitettujen käynnissä olevien VM:ien RAM.',
    baseMemoryHintNoTotal: 'VM:ille käytettävissä = havaittu kokonaismäärä − perusosa − tänne sijoitettujen käynnissä olevien VM:ien RAM.',
    baseCpu: 'Perus-CPU-ytimet',
    baseCpuHint: 'Havaitut loogiset CPU:t: {total}. Käytetään vain ranking-painona — vCPU-overcommit on normaalia.',
    baseCpuHintNoTotal: 'Käytetään vain ranking-painona — vCPU-overcommit on normaalia.',
    baseHint: 'RAM on tiukka admission-portti: VM, joka ei mahdu käytettävissä olevaan RAM-määrään, hylätään selittävällä virheellä. Nosta perusosaa hosteilla, jotka isännöivät storen jäseniä tai Ceph-daemoneja.',
    placementTitle: 'Fyysinen sijainti',
    placementSubtitle: 'Missä tämä palvelin fyysisesti on — ilmoitetaan kerran, mihin tahansa tarpeeseen',
    placementHint: 'Sijainti ohjaa jokaisen sellaisen Ceph-klusterin CRUSH-hierarkiaa, jolla on OSD tällä palvelimella: muutoksen tallentaminen linjaa niiden kartat uudelleen taskin kautta (host → rack → … → root). Osittaiset ilmoitukset ovat sallittuja — tyhjät tasot romahtavat kasaan. Nimet ovat yhteisiä koko kartalle: kaksi palvelinta samassa räkissä ilmoittavat saman räkin nimen.',
    placementNameInvalid: 'DNS-turvallinen nimi (pienaakkoset, numerot, tavuviivat)',
    placementEmpty: 'Tyhjä = ei ilmoitettu',
    placementLevel: {
      chassis: 'Kehikko',
      rack: 'Räkki',
      row: 'Rivi',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Huone',
      datacenter: 'Datakeskus',
      zone: 'Vyöhyke',
      region: 'Alue'
    },
    cablingTitle: 'Kaapelointi',
    cablingSubtitle: 'Mihin switchin porttiin kukin liitäntä on kytketty — ilmoitus elää solmulla (Annex O.9)',
    cablingHint: 'Yksi kaapeli NIC:iä kohden, yksi kaapeli porttia kohden koko laivastossa (API hylkää ja nimeää haltijan). Kaapelointi LAGGin jäsenporttiin on sallittua — se on bond-tapaus: tuleva derivointi renderöi sen LACP:nä.',
    cablingInterface: 'Liitäntä',
    cablingNotCabled: '— ei kytketty —',
    cablingNoInterfaces: 'Ei havaittuja verkkoliitäntöjä',
    disksTitle: 'Levyt',
    disksSubtitle: 'Havaitut lohkolaitteet — yksi skannaus täsmäytyskierrosta kohden; merkitse tässä Ceph-OSD:nä käytettävät levyt (N.15: kelpoisuus on eksplisiittistä)',
    colDataDisk: 'Datalevy',
    dataDisksHint: 'Laitteen ruksaaminen julistaa sen käytettäväksi OSD:nä; sarjanumero on sen identiteetin pin — kopioitu laitteistosta, kun levy raportoi sen, muuten TVirtin generoima (tvirt-…). Cephin rekisteröintidialogi tarjoaa vain julistetut levyt.',
    diskDeclaredSerial: 'ilmoitettu',
    diskNotObserved: 'ilmoitettu mutta ei havaittu — kytke laite takaisin tai poista ruksi',
    noDisks: 'Ei vielä havaittuja lohkolaitteita',
    colSerial: 'Sarjanumero',
    colModel: 'Malli',
    colSize: 'Koko (GiB)',
    colDiskType: 'Tyyppi',
    colInUse: 'Käytössä',
    colObservedAt: 'Havaittu',
    diskInUse: 'käytössä',
    diskFree: 'vapaa',
    diskMounted: 'mountattu',
    diskPartitions: 'osioita',
    passthroughTitle: 'Passthrough-laitteet',
    passthroughSubtitle: 'Havaitut GPU:t ja USB-laitteet — merkitse tässä, mitä TVirt voi välittää VM:ille; merkintä rekisteröi laitteen identiteetin (round U1+G1)',
    passthroughHint: 'Merkintä rekisteröi laitteen (vakaan id:n — tagien ja luokkavaatimusten kohteen). Merkityn GPU:n KOKO IOMMU-ryhmä sidotaan vfio-pci:hin kerralla — se poistuu hostilta heti; merkinnän poisto kiinnittää natiividriverin takaisin. USB:lle on olemassa molemmat ratifioidut mallit: laitekohtainen (vendor+product, mihin tahansa kytkettynä) ja fyysisen portin mukainen (VM:lle tulee mitä ikinä porttiin on työnnetty). USB ei bindaudu merkittäessä — attach tapahtuu VM:n ajon aikana.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'TVirtin käytettävissä',
    colGpu: 'GPU',
    colPciAddress: 'PCI-osoite',
    colDriver: 'Driver',
    colVerdict: 'Verdikti',
    gpuEligible: 'Kelvollinen',
    gpuIneligible: 'Ei kelvollinen',
    gpuReason: {
      'no-iommu': 'IOMMU ei ole käytössä hostilla',
      'group-spans-slots': 'IOMMU-ryhmä ei ole eristetty: se ulottuu muihin slotteihin',
      'multiple-display': 'IOMMU-ryhmä ei ole eristetty: useampi kuin yksi näyttöfunktio',
      'foreign-function': 'IOMMU-ryhmä ei ole eristetty: se sisältää vieraan funktion'
    },
    vfioNotReady: 'IOMMU ei ole käytössä tällä hostilla: yksikään GPU ei ole kelvollinen ennen kuin host-alusta ottaa sen käyttöön (OEM-ISO) — TVirt ei koskaan muokkaa kernel-argeja ajon aikana.',
    vfioMissingKernelArg: 'IOMMU ei ole käytössä tällä hostilla: firmware raportoi VT-d/AMD-Vi:n (ACPI-taulu DMAR/IVRS läsnä), mutta kernel arg puuttuu — lisää intel_iommu=on (Intel) tai poista amd_iommu=off (AMD) kernelin komentoriviltä ja käynnistä uudelleen. TVirt ei koskaan muokkaa kernel-argeja ajon aikana.',
    vfioFirmwareDisabled: 'IOMMU ei ole käytössä tällä hostilla: VT-d/AMD-Vi on poistettu käytöstä firmwaressa (ei ACPI-taulua DMAR/IVRS) tai CPU ei tue sitä — ota se käyttöön firmwaren setupissa, mikään kernel arg ei voi kytkeä sitä päälle. TVirt ei koskaan muokkaa hostia ajon aikana.',
    gpuBindError: 'vfio-pci-bind epäonnistui osoitteessa {address}: {error}',

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: 'Palomuuri hallinnoimattomilla silloilla',
    firewallBridgesSubtitle: 'Tämän solmun käsin rakennetut sillat, joiden setup suostuu TVirtin renderöimiin palomuuri-chaineihin liitetyissä guest-NIC:eissä',
    firewallBridgesHint: 'TVirt ei koskaan koske vieraaseen siltaan — chain ankkuroituu tap/vethiin, joka on aina TVirtin oma. Lista on suostumusportti: default-deny ja anti-spoof voivat rikkoa sen, mitä manuaalinen setup odottaa, joten palomuuria kantava NIC hallinnoimattomalla sillalla, jota EI ole listattu tässä, hylätään puhuvalla virheellä.',
    firewallBridgesEmpty: 'Yksikään hallinnoimaton silta ei suostu TVirtin renderöimiin palomuuri-chaineihin tällä solmulla.',
    firewallBridgeAdd: 'Lisää silta',
    firewallBridgeInvalid: 'Ei ole Linux-liitännän nimi (1-15 merkkiä, ei kauttaviivaa eikä välilyöntiä)',
    firewallBridgeDuplicate: 'Nimi on jo listalla',
    colMarkDevice: 'Laitekohtainen',
    colMarkPort: 'Porttikohtainen',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Portti',
    passthroughOrphan: 'orpo — rekisteröity mutta ei enää havaittu: kytke se takaisin tai poista merkintä',
    noGpus: 'Ei vielä havaittuja GPU:ita',
    noUsb: 'Ei vielä havaittuja USB-laitteita',
    networkGeneration: 'Verkkogeneraatio',
    applied: 'Otettu käyttöön',
    converged: 'ajan tasalla',
    behind: 'jäljessä — {m} / {n}',
    notConfigured: 'ei konfiguroitu',
    rollbackBody: 'Generaation {gen} käyttöönotto epäonnistui: {error}',
    rolledBackChip: 'rollback suoritettu',
    nicsTitle: 'NIC',
    nicsSubtitle: 'Hallittujen NIC:ien rekisteri — rekisteröinti ON hallinnan julistus: rekisteröityyn NIC:iin ilman konfiguraatiota ei kosketa (clear-if julistaa sen eksplisiittisesti puhtaaksi), rekisteröimättömään laitteeseen ei kosketa koskaan',
    addNic: 'Rekisteröi NIC',
    addNicTitle: 'Rekisteröi NIC (add-nic)',
    delNic: 'Lopeta hallinta',
    delNicTitle: 'Lopeta hallinta (del-nic)',
    delNicConfirm: 'Laitteen {name} hallinta päättyy: rekisterimerkintä ja sen konfiguraatio poistetaan ja TVirt-profiili puretaan — laite jää sellaiseksi kuin Linux sen pitää.',
    nicName: 'Laitteen nimi',
    nicMac: 'Pysyvä MAC-osoite',
    nicMacHint: 'pysyvä laitteisto-MAC — TVirt Server Installerin kiinnittämä vakaa identiteetti',
    colObserved: 'Havaittu',
    nicObserved: 'havaittu',
    nicNotObserved: 'ei havaittu',
    nicMacMismatch: 'MAC poikkeaa — havaittu {mac}',
    noNics: 'Ei rekisteröityjä NIC:ejä — rekisteröi laite aloittaaksesi sen hallinnan',
    noManagedDevices: 'Ei hallittuja laitteita — rekisteröi ensin NIC, kaikki rakentuu rekisterin päälle',
    inventoryTitle: 'Havaitut laitteet',
    inventorySubtitle: 'Solmun worker päivittää nämä jokaisella täsmäytyskierroksella — validointi tarkistaa laitenimet tätä inventaariota vasten',
    colDevice: 'Laite',
    colType: 'Tyyppi',
    colMac: 'MAC',
    colLink: 'Linkki',
    colSpeed: 'Nopeus',
    colTopology: 'Topologia',
    colMtu: 'MTU',
    colAddresses: 'Osoitteet',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP ei aggregoi',
    noInventory: 'Ei vielä raportoituja laitteita',
    interfacesTitle: 'Liitännät',
    interfacesSubtitle: 'Rekisteröityjen NIC:ien ja ilmoitettujen loogisten laitteiden L3-konfiguraatio — set-if korvaa koko lohkon, edit-if hienosäätää ominaisuuksia, clear-if tyhjentää sen (eksplisiittinen puhdistus)',
    colConfig: 'Haluttu konfiguraatio',
    clean: 'puhdas',
    setIf: 'Muokkaa osoitteistusta',
    setIfTitle: 'Muokkaa osoitteistusta (set-if)',
    editIf: 'Muokkaa ominaisuuksia',
    editIfTitle: 'Muokkaa ominaisuuksia (edit-if)',
    clearIf: 'Tyhjennä konfiguraatio',
    clearIfTitle: 'Tyhjennä konfiguraatio (clear-if)',
    clearIfConfirm: 'Liitännän konfiguraatio tyhjennetään. Puhdas liitäntä on edellytys sen valjastamiselle bondin/bridgen jäseneksi tai VLANin parentiksi.',
    ip4Mode: 'IPv4-tila',
    ip6Mode: 'IPv6-tila',
    modeUnconfigured: 'Ei konfiguroitu',
    modeStatic: 'Staattinen',
    modeDhcp: 'DHCP',
    ip4Addresses: 'IPv4-osoitteet',
    ip6Addresses: 'IPv6-osoitteet',
    addressesHint: 'CIDR-muodossa, pilkuin eroteltuina',
    gw4: 'IPv4-gateway',
    gw6: 'IPv6-gateway',
    dns: 'DNS-palvelimet',
    dnsHint: 'pilkuin eroteltuina — tyhjä nollaa DNS:n (set-if korvaa lohkon)',
    routes4: 'Staattiset IPv4-reitit',
    routes6: 'Staattiset IPv6-reitit',
    routeTo: 'Kohde (CIDR)',
    routeVia: 'Kautta',
    addRoute: 'Lisää reitti',
    routesChip: 'reittiä',
    mtu: 'MTU',
    mtuHint: 'tyhjä = driverin oletus',
    vlansTitle: 'VLAN',
    addVlan: 'Lisää VLAN',
    addVlanTitle: 'Lisää VLAN (add-vlan)',
    delVlanTitle: 'Poista VLAN (del-vlan)',
    vlanParent: 'Parent-liitäntä',
    vlanId: 'VLAN-ID',
    vlanPreview: 'Laitteen nimi',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Ei ilmoitettuja VLANeja',
    bondsTitle: 'Bondit',
    addBond: 'Lisää bond',
    addBondTitle: 'Lisää bond (add-bond)',
    editBondTitle: 'Muokkaa bondia',
    editBond: 'Tallenna bond',
    delBondTitle: 'Poista bond (del-bond)',
    bondName: 'Bondin nimi',
    members: 'Jäsenet',
    membersHint: 'jäsenten on oltava puhtaita liitäntöjä (ilman L3-konfiguraatiota)',
    bondMode: 'Moodi',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Ensisijainen jäsen',
    rate: 'LACP-rate',
    hash: 'Lähetyksen hash-politiikka',
    colMembers: 'Jäsenet',
    colMode: 'Moodi',
    noBonds: 'Ei ilmoitettuja bondeja',
    bridgesTitle: 'Bridget',
    addBridge: 'Lisää bridge',
    addBridgeTitle: 'Lisää bridge (add-bridge)',
    editBridgeTitle: 'Muokkaa bridgeä',
    editBridge: 'Tallenna bridge',
    delBridgeTitle: 'Poista bridge (del-bridge)',
    bridgeName: 'Bridgen nimi',
    stp: 'STP',
    stpOn: 'STP käytössä',
    stpOff: 'STP pois käytöstä',
    colStp: 'STP',
    noBridges: 'Ei ilmoitettuja bridgejä',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Aseta hostname',
    setHostnameTitle: 'Aseta hostname (set-hostname)',
    hostnameHint: 'Vain OS-identiteetti — solmun nimeen klusterissa ei kosketa',
    notSet: 'ei asetettu',
    staticHostsTitle: 'Staattiset host-merkinnät',
    addStaticHost: 'Lisää merkintä',
    addStaticHostTitle: 'Lisää staattinen host-merkintä',
    delStaticHostTitle: 'Poista staattinen host-merkintä',
    hostIp: 'IP-osoite',
    hostNames: 'Nimet',
    hostNamesHint: 'pilkuin tai välilyönnein eroteltuina',
    colIp: 'IP',
    colNames: 'Nimet',
    noStaticHosts: 'Ei staattisia host-merkintöjä',
    delConfirm: 'Kohde {name} poistetaan halutusta dokumentista — solmun worker konvergoi NetworkManagerin checkpointin ja automaattisen rollbackin kanssa.',
    remove: 'Poista',
    opError: 'Verkko-operaatio hylättiin'
  }
}
